import React from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

function LoadDocs({ title, buttonSave, funtionButton, disabledButton, toggle, openModal, ...props }) {
	return (
		<>
			<div className="d-flex justify-content-end">
				<i className='fas fa-plus-circle fa-2x buton-add' onClick={toggle} />
			</div>
			<Modal isOpen={openModal} toggle={toggle}>
				<ModalHeader toggle={toggle}
				>{title}</ModalHeader>
				<ModalBody>
					{props.children}
				</ModalBody>
				<ModalFooter>
					<Button color="primary" disabled={disabledButton} onClick={() => { funtionButton() }}>
						{buttonSave}
					</Button>{' '}
				</ModalFooter>
			</Modal >
		</>
	)
}

export default withNamespaces()(withRouter(LoadDocs));

